import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import css_248z from './headline.scss.js';

class Headline extends s {
    constructor() {
        super(...arguments);
        this.size = 'medium';
        this.textAlign = 'left';
        this.titlecolor = 'black';
    }
    render() {
        const sizeClasses = {
            [`size-${this.size}`]: true,
            [`text-align-${this.textAlign}`]: true,
            [`title-color-${this.titlecolor}`]: true,
        };
        return x `<h1 class="headline ${o(sizeClasses)}"><slot></slot></h1>`;
    }
}
Headline.styles = css_248z;
__decorate([
    n({ type: String })
], Headline.prototype, "size", void 0);
__decorate([
    n({ type: String })
], Headline.prototype, "textAlign", void 0);
__decorate([
    n({ type: String })
], Headline.prototype, "titlecolor", void 0);
customElements.define('headline-block', Headline);

export { Headline };
